import React from 'react'

export default function UnderlineTabs({ tabs, activeTab, onTabChange, className = '' }) {
  return (
    <div className={`flex w-full gap-8 ${className}`}>
      {tabs.map((tab) => {
        const isActive = activeTab === tab.id

        return (
          <button
            key={tab.id}
            type="button"
            onClick={() => onTabChange?.(tab.id)}
            className={`-mb-px border-b-2 pb-3 text-sm font-semibold transition-colors ${
              isActive
                ? 'border-rb-green text-rb-green'
                : 'border-transparent text-rb-lighter-grey hover:text-rb-black dark:text-gray-400 dark:hover:text-white'
            }`}
          >
            {tab.label}
          </button>
        )
      })}
    </div>
  )
}
